export const modalTypes = {
  SHOW_MODAL: "showModal",
  SAVE_SNAPSHOT: "SAVE_SNAPSHOT",
  CONFIRMATION: "CONFIRMATION",
  RENAME_SNAPSHOT: "RENAME_SNAPSHOT",
  CREATE_DICTIONARY: "CREATE_DICTIONARY",
  CREATE_DICTIONARY_SUCCESS: "CREATE_DICTIONARY_SUCCESS",
  ADD_USER_TO_WORKSPACE: "ADD_USER_TO_WORKSPACE",
  ERROR: "ERROR",
  DELETE_WORKSPACE: "DELETE_WORKSPACE",
  WORKSPACE_RESERVED_LICENSES: "WORKSPACE_RESERVED_LICENSES",
  WORKSPACE_BANNER: "WORKSPACE_BANNER",
  ANONYMIZE_USERS: "ANONYMIZE_USERS",
  EDIT_PERMISSIONS: "EDIT_PERMISSIONS",
  EXPORT_REPORT: "EXPORT_REPORT",
  NEW_USER: "NEW_USER",
  EDIT_USER: "EDIT_USER",
  IMPORT_USERS: "IMPORT_USERS",
  EDIT_USER_AND_PERMISSIONS: "EDIT_USER_AND_PERMISSIONS",
  ENABLE_SSO: "ENABLE_SSO",
  ENABLE_USERNAME_PASSWORD: "ENABLE_USERNAME_PASSWORD", // NOSONAR javascript:S2068 - modal type identifier, not a credential
  ABOUT_VT_DOCS: "ABOUT_VT_DOCS",
  CHANGE_PASSWORD: "CHANGE_PASSWORD", // NOSONAR javascript:S2068 - modal type identifier, not a credential
  DICTIONARY_DOCUMENTS_AND_FOLDERS: "DICTIONARY_DOCUMENTS_AND_FOLDERS",
  INFO_BANNER: "INFO_BANNER",
  IMPORT_DICTIONARY: "IMPORT_DICTIONARY",
  TEXT_FIELD_MODAL: "TEXT_FIELD_MODAL",
  IMPORT_FILE: "IMPORT_FILE",
  CHANGE_DICTIONARY: "CHANGE_DICTIONARY",
  EXPORT_MULTIPLE_DOCS: "EXPORT_MULTIPLE_DOCS",
  EXPORT_CONTENT: "EXPORT_CONTENT",
  ANNOTATED_DOCUMENT: "ANNOTATED_DOCUMENT",
  SHRED_ANNOTATED_DOCUMENT: "SHRED_ANNOTATED_DOCUMENT",
  SHRED_TO_EXCEL: "SHRED_TO_EXCEL",
  DISCOVERY_EXPORT_MULTIPLE_DOCS: "DISCOVERY_EXPORT_MULTIPLE_DOCS",
  RESET_DEFAULTS_THRESHOLDS: "RESET_DEFAULTS_THRESHOLDS",
  IGNORE_TERM_CONFIRM: "IGNORE_TERM_CONFIRM",
  CREATE_NEW_DICTIONARY: "CREATE_NEW_DICTIONARY",
  UPLOAD_FILES: "UPLOAD_FILES",
  UPLOAD_EXTERNAL_FILES: "UPLOAD_EXTERNAL_FILES",
  SELECT_FOLDER: "SELECT_FOLDER",
  COMPARE_DOCUMENTS: "COMPARE_DOCUMENTS",
  CHOOSE_DOCUMENTS: "CHOOSE_DOCUMENTS",
  ACRONYM_REPORT: "ACRONYM_REPORT",
  DATE_RANGE: "DATE_RANGE",
  EDIT_LICENSING: "EDIT_LICENSING",
  PASSWORD_EXPIRY: "PASSWORD_EXPIRY", // NOSONAR javascript:S2068 - modal type identifier, not a credential
  CREATE_WORKSPACE_WITH_LICENSING: "CREATE_WORKSPACE_WITH_LICENSING",
  CREATE_NEW_CATEGORY: "CREATE_NEW_CATEGORY",
  SELECT_DOCUMENT: "SELECT_DOCUMENT",
  DOCUMENT_READABILITY_REPORT_OPTIONS: "DOCUMENT_READABILITY_REPORT_OPTIONS",
  CHOOSE_FILES: "CHOOSE_FILES",
  HAS_UNSAVED_CHANGES: "HAS_UNSAVED_CHANGES",
  DOCUMENT_STALE_RELOAD: "DOCUMENT_STALE_RELOAD",
  GENERIC_DELETE_MODAL: "GENERIC_DELETE_MODAL",
  CANCEL_ANALYSIS_MODAL: "CANCEL_ANALYSIS_MODAL",
  SELECT_UPLOADED_DOCUMENTS: "SELECT_UPLOADED_DOCUMENTS",
  ANNOTATED_ACRONYM_REPORT_SELECTION: "ANNOTATED_ACRONYM_REPORT_SELECTION",
  LOADING_MODAL: "LOADING_MODAL",
  COLLECTIONS_MODAL: "COLLECTIONS_MODAL",
  MANUAL_OPP_FORM_NOT_EMPTY: "MANUAL_OPP_FORM_NOT_EMPTY",
  LAST_UPDATED_CUSTOM_RANGE: "LAST_UPDATED_CUSTOM_RANGE",
  HEADING_SYNC_MODAL: "HEADING_SYNC_MODAL",
  START_WRITING_PROPOSAL_OUTLINE_WIZARD:
    "START_WRITING_PROPOSAL_OUTLINE_WIZARD",
  HEADING_DELETE_MODAL: "HEADING_DELETE_MODAL",
  DETACH_DOCUMENT_MODAL: "DETACH_DOCUMENT_MODAL",
  DOCUMENT_SYNC_PROGRESS: "DOCUMENT_SYNC_PROGRESS",
  UNARCHIVE_PROPOSAL: "UNARCHIVE_PROPOSAL",
  ARCHIVE_ENTITY_MODAL: "ARCHIVE_ENTITY_MODAL",
  COLLECTION_REINDEX_PROGRESS: "COLLECTION_REINDEX_PROGRESS",
  IMPORT_PROMPT_LIBRARY_CSV: "IMPORT_PROMPT_LIBRARY_CSV",
  SCORING_SWAP_WATCHWORDS_LIST: "SCORING_SWAP_WATCHWORDS_LIST",
  CHOOSE_SHRED_DOCUMENT: "CHOOSE_SHRED_DOCUMENT",
  ADD_IN_CONFIRM_OUTLINE_INSERT: "ADD_IN_CONFIRM_OUTLINE_INSERT",
  ADD_IN_NAME_CLASH_PROMPT: "ADD_IN_NAME_CLASH_PROMPT",
  ADD_IN_TURN_OFF_AUTOSAVE: "ADD_IN_TURN_OFF_AUTOSAVE",
  SESSION_TIMEOUT_WARNING: "SESSION_TIMEOUT_WARNING",
  NEW_OPPORTUNITY_CHOOSER: "NEW_OPPORTUNITY_CHOOSER",
  NEW_PROPOSAL_CHOOSER: "NEW_PROPOSAL_CHOOSER",
  PIPELINE_BY_OWNER: "PIPELINE_BY_OWNER",
  PIPELINE_FUNNEL: "PIPELINE_FUNNEL",
  PIPELINE_VALUE_BY_CUSTOMER: "PIPELINE_VALUE_BY_CUSTOMER",
  SECTION_STATUS: "SECTION_STATUS",
  TIME_IN_STAGE: "TIME_IN_STAGE",
  TOTAL_PIPELINE: "TOTAL_PIPELINE",
  TRACKED_OPPORTUNITY_PICKER: "TRACKED_OPPORTUNITY_PICKER",
  RECALC_PROGRESS: "RECALC_PROGRESS",
  CLARIFICATION_REQUIRED: "CLARIFICATION_REQUIRED",
  LOCKED_ITEMS_MODAL: "LOCKED_ITEMS_MODAL",
  AUP_ACCEPTANCE: "AUP_ACCEPTANCE",
  CONFIRM_DOC_STYLE_TEMPLATE_MODAL: "CONFIRM_DOC_STYLE_TEMPLATE_MODAL",
  KANBAN_ADD_STAGE_GATE_QUESTION: "KANBAN_ADD_STAGE_GATE_QUESTION",
  KANBAN_GATE_MOVE_MODAL: "KANBAN_GATE_MOVE_MODAL",
  GATE_PREVIEW_MODAL: "GATE_PREVIEW_MODAL",
  DELETE_OUTLINE_SECTIONS_MODAL: "DELETE_OUTLINE_SECTIONS_MODAL",
  DELETE_OUTLINE_MODAL: "DELETE_OUTLINE_MODAL",
  COMBINE_OUTLINE_DOCS_MODAL: "COMBINE_OUTLINE_DOCS_MODAL",
  CASCADE_ASSIGNEE_MODAL: "CASCADE_ASSIGNEE_MODAL",
  CASCADE_STATUS_MODAL: "CASCADE_STATUS_MODAL",
  ARCHIVE_STATUS_REASSIGN_MODAL: "ARCHIVE_STATUS_REASSIGN_MODAL",
  SHREDDING_TEMPLATE_FORM: "SHREDDING_TEMPLATE_FORM",
  SHREDDING_TEMPLATE_COLUMN: "SHREDDING_TEMPLATE_COLUMN",
  SHREDDING_TEMPLATE_GROUP: "SHREDDING_TEMPLATE_GROUP",
  RENAME_SHRED_COLUMN: "RENAME_SHRED_COLUMN",
  DUPLICATE_SHRED_COLUMN: "DUPLICATE_SHRED_COLUMN",
  RENAME_SHRED_GROUP: "RENAME_SHRED_GROUP",
  DUPLICATE_SHRED_GROUP: "DUPLICATE_SHRED_GROUP",
  OPPORTUNITY_TO_PROPOSAL: "OPPORTUNITY_TO_PROPOSAL",
  ARCHIVED_BY_REASON: "ARCHIVED_BY_REASON",
  DISABLE_AI_FEATURE_MODAL: "DISABLE_AI_FEATURE_MODAL",
  LLM_PROVIDER_MODAL: "LLM_PROVIDER_MODAL",
  PROPOSAL_ASSIGNMENT: "PROPOSAL_ASSIGNMENT",
  PROPOSAL_SECTIONS_ASSIGNMENT: "PROPOSAL_SECTIONS_ASSIGNMENT",
  CUSTOM_FIELD: "CUSTOM_FIELD",
  CUSTOM_FIELD_DELETE: "CUSTOM_FIELD_DELETE",
};

export const snapshotLoadingTypes = {
  NOT_LOADING: "notLoading",
  INITIAL_LOADING: "initialLoading",
  LOAD_CHECKED_ITEMS: "loadCheckedItems",
  LOAD_SHOW_SELECTED: "loadShowSelected",
};

export const elements = {
  CONTENT: "content",
  BY_CONTENT_VIEW: "byContentView",
};

export const httpMethods = {
  GET: "get",
  DELETE: "delete",
  POST: "post",
  PUT: "put",
  PATCH: "patch",
};

export const checkedTypes = {
  EMPTY: "empty",
  INDETERMINATE: "indeterminate",
  CHECKED: "checked",
};
